import { c as _c } from "react/compiler-runtime";
import { client } from "../../../shared/utils/thirdweb.js";
import { debugB3React } from "../../../shared/utils/debug.js";
import { useCallback, useEffect, useRef } from "react";
import { getLastAuthProvider, useAddConnectedWallet, useConnectedWallets, useSetActiveWallet } from "thirdweb/react";
import { EIP1193 } from "thirdweb/wallets";
import { useAuthStore } from "../stores/index.js";
const debug = debugB3React("useAutoSelectWallet");
/**
 * Hook to automatically connect a default EOA provider (if given) and
 * select the first EOA wallet when user is authenticated.
 * Only auto-selects if the last auth was via wallet or no previous auth provider.
 */
export function useAutoSelectWallet(t0) {
  const $ = _c(12);
  const {
    enabled,
    defaultEoaProvider
  } = t0;
  const isAuthenticated = useAuthStore(_temp);
  const wallets = useConnectedWallets();
  const setActiveWallet = useSetActiveWallet();
  const addConnectedWallet = useAddConnectedWallet();
  const hasConnectedProvider = useRef(false);
  let t1;
  let t2;
  if ($[0] !== addConnectedWallet || $[1] !== defaultEoaProvider) {
    t1 = () => {
      if (!defaultEoaProvider || hasConnectedProvider.current) {
        return;
      }
      hasConnectedProvider.current = true;
      const connectDefaultProvider = async () => {
        ;
        try {
          const wallet = EIP1193.fromProvider({
            provider: defaultEoaProvider
          });
          await wallet.connect({
            client
          });
          addConnectedWallet(wallet);
          debug("Auto-connected default EOA provider", wallet.id);
        } catch (t3) {
          const error = t3;
          debug("Failed to auto-connect default EOA provider", error);
          hasConnectedProvider.current = false;
        }
      };
      connectDefaultProvider();
    };
    t2 = [defaultEoaProvider, addConnectedWallet];
    $[0] = addConnectedWallet;
    $[1] = defaultEoaProvider;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== setActiveWallet) {
    t3 = wallet_0 => {
      debug("@@setWallet", wallet_0.id, wallet_0.getAccount()?.address);
      setActiveWallet(wallet_0);
    };
    $[4] = setActiveWallet;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const setWallet = t3;
  let t4;
  let t5;
  if ($[6] !== enabled || $[7] !== isAuthenticated || $[8] !== setWallet || $[9] !== wallets) {
    t4 = () => {
      const autoSelectFirstEOAWallet = async () => {
        if (!enabled || !isAuthenticated) {
          return;
        }
        const isEOAWallet = _temp2;
        const firstEOAWallet = wallets.find(isEOAWallet);
        if (firstEOAWallet) {
          const lastAuthProvider = await getLastAuthProvider();
          const shouldAutoSelect = lastAuthProvider === null || lastAuthProvider === "wallet";
          if (shouldAutoSelect) {
            debug("Auto-selecting first EOA wallet", firstEOAWallet.id);
            setWallet(firstEOAWallet);
          }
        }
      };
      autoSelectFirstEOAWallet();
    };
    t5 = [enabled, isAuthenticated, setWallet, wallets];
    $[6] = enabled;
    $[7] = isAuthenticated;
    $[8] = setWallet;
    $[9] = wallets;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
}
function _temp2(wallet_1) {
  return !wallet_1.id.startsWith("ecosystem.");
}
function _temp(state) {
  return state.isAuthenticated;
}